export function createUrl(url, parameters, defaultParameters = {}) {
    const allParameters = {
        ...defaultParameters,
        ...parameters
    }

    url += "?"
    for (let key in allParameters) {
        // ex: {'order': {'name' : 'asc'}}
        if (key === 'order') {
            for (let orderField in allParameters[key]) {
                url += 'order['+ orderField + "]=" + allParameters[key][orderField] + '&'
            }
        } else {
            url += key + "=" + allParameters[key] + '&'
        }
    }
    return url.substr(0, url.length - 1)
}

export function getObjects(url) {
    return fetch(url, {
        credentials: 'include'
    })
        .then(response => {
            return response.json()
        })
}

export function getObject(url) {
    return fetch(url, {
        credentials: 'include'
    })
        .then(response => {
            return response.json()
        })
}

export function putObject(url, putValues = {}) {
    return fetch(url, {
        method: "PUT",
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(putValues)
    })
        .then(response => {
            return response.json()
        })
}

export function postObject(url, postData) {
    return fetch(url, {
        method: "POST",
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include',
        body: JSON.stringify(postData)
    })
        .then(response => {
            // console.log("POST response", response)
            if (response.status !== 204)
                return response.json()
            else
                return response
        })
}

export function deleteObject(url) {
    return fetch(url, {
        method: "DELETE",
        headers: {
            'Content-Type': 'application/json'
        },
        credentials: 'include'
    })
}